
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("i3uiK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4932f6dfff92518aeab5d46f90dd8b8a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2500301d11eaf38$var$_react = $d2500301d11eaf38$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $d2500301d11eaf38$var$_baseNew = $d2500301d11eaf38$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d2500301d11eaf38$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CreditCard".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: billing in Admin, invoices in PPC, payments.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d2500301d11eaf38$var$CreditCardIcon = (props)=>/*#__PURE__*/ $d2500301d11eaf38$var$_react.default.createElement($d2500301d11eaf38$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1.5h13V4a.5.5 0 0 0-.5-.5zM14.5 7h-13v5a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zM9 9.5h4V11H9z" clip-rule="evenodd"/>`
    }, props));
$d2500301d11eaf38$var$CreditCardIcon.displayName = 'CreditCardIcon';
var $d2500301d11eaf38$var$_default = module.exports.default = $d2500301d11eaf38$var$CreditCardIcon;

});


//# sourceMappingURL=credit-card.9743f51c.js.map
